module.exports = __webpack_public_path__ + "img/TV_AMENITY.00486260.svg";